import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { ENV } from '@environment';
import { MyThunkDispatch } from 'store';

import { setOAuthEmail } from 'action-creators/user';
import { Mobile } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Header, Subheader, NextButton, ButtonsContainer, CenteredImage } from '../../styles';
import ChoiceButton from './components/ChoiceButton';
import { ChoicesContainer } from './styles';

interface Props {
  onSubmit: (value: boolean) => void;
  inviteEmail: string;
}

const RappiAccount = ({ onSubmit, inviteEmail }: Props) => {
  const { t } = useStoreTranslation();
  const dispatch: MyThunkDispatch = useDispatch();

  const [hasRappiAccount, setHasRappiAccount] = useState<boolean | undefined>();

  const handleSubmit = () => {
    if (hasRappiAccount === undefined) return;

    dispatch(setOAuthEmail(inviteEmail));

    if (hasRappiAccount) {
      window.location.href = `${ENV.RAPPI_OAUTH.LOGIN_URL}?client_id=${ENV.RAPPI_OAUTH.LOGIN_CLIENTID}&redirect_uri=${
        ENV.RAPPI_OAUTH.REDIRECT_URL_FROM_INVITE
      }&response_type=code&scope=all&flowName=GeneralOAuthFlow&state=${Math.random()}&subdomain=travel-corporate`;
    } else {
      window.location.href = `${ENV.RAPPI_OAUTH.SIGNUP_URL}?client_id=${ENV.RAPPI_OAUTH.LOGIN_CLIENTID}&redirect_uri=${
        ENV.RAPPI_OAUTH.REDIRECT_URL_FROM_INVITE
      }&response_type=code&scope=all&flowName=GeneralOAuthFlow&state=${Math.random()}&subdomain=travel-corporate`;
    }

    //onSubmit(hasRappiAccount);
  };

  return (
    <Container>
      <Mobile>
        <CenteredImage marginBottom={48} width={120} src="/corporate/images/logo-netviajes.svg" />
      </Mobile>

      <Header>{t('invite.rappiAccount.title')}</Header>

      <Subheader>{t('invite.rappiAccount.subtitle')}</Subheader>

      <ChoicesContainer>
        <ChoiceButton
          title={t('invite.rappiAccount.yes')}
          detail={t('invite.rappiAccount.yesDetail')}
          isSelected={hasRappiAccount === true}
          onClick={() => setHasRappiAccount(true)}
        />
        <ChoiceButton
          title={t('invite.rappiAccount.no')}
          detail={t('invite.rappiAccount.noDetail')}
          isSelected={hasRappiAccount === false}
          onClick={() => setHasRappiAccount(false)}
        />
      </ChoicesContainer>

      <ButtonsContainer>
        <NextButton disabled={hasRappiAccount === undefined} onClick={handleSubmit}>
          {t('invite.nextButton')}
        </NextButton>
      </ButtonsContainer>
    </Container>
  );
};

export default RappiAccount;
